// extracted by mini-css-extract-plugin
export default {"userInfo":"HeaderAvatarInfo_userInfo__o1giQ","nameContainer":"HeaderAvatarInfo_nameContainer__x-BrD","name":"HeaderAvatarInfo_name__Tcu11"};